import { render, staticRenderFns } from "./RegistrationBanquet.vue?vue&type=template&id=7e12bae5&scoped=true"
import script from "./RegistrationBanquet.vue?vue&type=script&lang=js"
export * from "./RegistrationBanquet.vue?vue&type=script&lang=js"
import style0 from "./RegistrationBanquet.vue?vue&type=style&index=0&id=7e12bae5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e12bae5",
  null
  
)

export default component.exports